export default __webpack_public_path__ + "static/media/minus.2e71f007.svg";